import { getUseBotOnboardingStore } from '../stores/useBotOnboardingStore'
import { useWorkflowStore, getApiClient } from '~/stores'
import { useEffect, useRef } from 'react'

const FINISHED_STATUS = ['completed', 'cancelled', 'timedout', 'failed']

export function usePollIndexingFiles({ workspaceId, botId }: { workspaceId: string; botId: string }) {
  const workflows = useWorkflowStore((state) => state.workflows)
  const useBotOnboardingStore = getUseBotOnboardingStore({ botId, workspaceId })
  const deploymentWorkflowId = useBotOnboardingStore((state) => state.deploymentWorkflowId)
  const setIsIndexing = useBotOnboardingStore((state) => state.setIsIndexing)
  const setIndexedFiles = useBotOnboardingStore((state) => state.setIndexedFiles)
  const indexedFiles = useBotOnboardingStore((state) => state.indexedFiles)

  const activePollingTimerId = useRef<NodeJS.Timeout | undefined>(undefined)

  useEffect(() => {
    if (!deploymentWorkflowId) {
      setIsIndexing(false)
      return
    }

    if (activePollingTimerId.current) return

    setIsIndexing(true)
    pollFiles()

    activePollingTimerId.current = setInterval(pollFiles, 2000)
    handleStopPolling()

    return () => {
      if (activePollingTimerId.current) {
        clearInterval(activePollingTimerId.current)
        activePollingTimerId.current = undefined
      }
    }
  }, [deploymentWorkflowId, workflows])

  const handleStopPolling = () => {
    if (FINISHED_STATUS.includes(workflows[deploymentWorkflowId ?? '']?.status ?? '')) {
      clearInterval(activePollingTimerId.current)
      activePollingTimerId.current = undefined
      setIsIndexing(false)
    }
  }

  if (deploymentWorkflowId) {
    handleStopPolling()
  }

  const pollFiles = async () => {
    const apiClient = getApiClient({ botId, workspaceId })
    const files = await apiClient.list
      .files({
        sortField: 'status',
        sortDirection: 'asc',
        tags: { kbId: 'kb-default' },
      })
      .collect()

    for (const file of files) {
      if (file.status !== 'indexing_completed') continue

      if (!indexedFiles.some((f) => f.name === file.key)) {
        setIndexedFiles([...indexedFiles, { name: file.key, type: file.contentType }])
      }
    }
  }
  return { indexedFiles }
}
